import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { getUserInfo } from "../../services/account-setting.services";
import { SaveBankDetails } from "../../services/stripe.servic4e";
import Swal from "sweetalert2";

export default function AddBankDetails() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      bank_details: "",
    },
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await getUserInfo();

        if (response?.success && response?.data) {
          setValue("bank_details", response.data.bank_details || "");
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Bank Details",
          text: "Failed to load bank details",
          confirmButtonColor: "#F27438",
        });
      }
    };
    fetchUserInfo();
  }, [setValue]);

  const onSubmit = async (data) => {
    try {
      const response = await SaveBankDetails({ bank_details: data.bank_details });

      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message || "Bank details saved successfully!",
          confirmButtonColor: "#F27438",
        });
        navigate("/business/account-setting/add-bank-details");
      } else {
        Swal.fire({
          icon: "error",
          title: "Save Failed",
          text: response?.message || "Failed to save bank details",
          confirmButtonColor: "#F27438",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving bank details.",
        confirmButtonColor: "#F27438",
      });
    }
  };

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="container form-wrapper section-section" style={{ boxShadow: "none" }}>
            <h4 className="h3-headline mb-5 text-center">Add Bank Details</h4>

            <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "2rem" }}>
              <div className="form-group">
                <label className="form-label subtitle-1" htmlFor="bank_details">
                  Bank Details<span className="requirestar">*</span>
                </label>
                <textarea
                  id="bank_details"
                  {...register("bank_details", {
                    required: "Bank details are required",
                    setValueAs: (value) => value.trim(),
                    validate: (value) => value.trim().length > 0 || "Bank details cannot be only spaces",
                  })}
                  className="form-control mw-100"
                  rows={5}
                  placeholder="Enter your bank account details (account name, IBAN, bank name, etc.)"
                />
                {errors.bank_details && <p className="text-danger mt-1">{errors.bank_details.message}</p>}
              </div>

              <div className="text-center mt-5">
                <button type="submit" className="btn btn-oring" disabled={isSubmitting}>
                  {isSubmitting ? "Saving..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
